import React from 'react'
import DeliveryMobile from './delivery.mobile'

export interface IProps {
  handleOpenMap: (e?: any) => void
}

const DeliveryType = (props: IProps) => {
  return <DeliveryMobile {...props} />
}

export default DeliveryType
